import '../../../styles/res.scss';
import { MyContext } from '@/utils/contextManager';
import React, { useState, useEffect, useRef, useContext } from 'react';
import { ListView, Tag, PullToRefresh } from 'antd-mobile';
import { last } from 'lodash';
import { getCategory, list } from '../../../services/saas/res';
import { getDefaultCover } from '../../../utils';
import { useHistory } from 'react-router';
import sysConfig from '../../../sysConfig';
import SearchWrapper from '@/components/searchWrapper';
import Filter from '@/components/filter';
const { preRouteUrl } = sysConfig;

function ListWrap(props) {
  return <ul className="res-list">{props.children}</ul>;
}

const getDefaultData = async (resCategory) => {
  const filterList = {};

  const resp = await getCategory({ id: resCategory });
  if (resp.success && resp.data) {
    filterList[resp.data.id] = {
      child: undefined,
      label: resp.data.categoryName,
      list: resp.data.children?.map((item) => ({
        name: item.categoryName,
        value: item.id,
      })),
    };
  }
  return filterList;
};

function ResList(props) {
  const { resCategory, attribute } = props.config || { resCategory: '' };
  const pageSize = 5;
  const [draging, setDraging] = useState(false);
  const [attrData, setAttrData] = useState([]);
  const { setFilters } = useContext(MyContext);
  const [name, setSearchName] = useState('');
  const [filter, setFilter] = useState({});
  let [pageIndex, setIndex] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { res: resCover } = getDefaultCover();
  const dataS = new ListView.DataSource({
    getRowData: (dataBlob, sectionID, rowID) => {
      return dataBlob[sectionID][rowID];
    },
    rowHasChanged: (row1, row2) => row1 !== row2,
  });
  const [dataSource, setDataSouce] = useState(dataS);

  const getData = async function (page) {
    setLoading(true);
    if (!page) {
      page = 1;
    }
    const param = {
      current: page,
      size: pageSize,
      title: name,
    };
    if (attribute) {
      param.resAttributeDetailList = JSON.stringify(attribute.value);
    }
    const response = await list({
      categoryId: (filter.categoryId ? filter.categoryId[0] : '') || resCategory,
      issueFlag: '1',
      ...param,
    });
    if (response.success && response.data) {
      let resList = [];
      if (page !== 1) {
        resList = [...data];
      }
      resList = [
        ...resList,
        ...response.data.records.map((item) => ({
          resId: item.resId,
          title: item.title,
          coverUrl: item.coverUrl,
          deptName: item.deptName,
          createrName: item.createrName,
          resAttributeDetailList: item.resAttributeDetailList,
        })),
      ];
      setLoading(false);
      setData(resList);
      setDataSouce(dataSource.cloneWithRows(resList));
      setHasMore(response.data.current < response.data.pages);
      setIndex(page);
      setDraging(false);
    }
  };

  const getAttrData = async () => {
    const data = await getDefaultData(resCategory);
    setAttrData({ ...data });
  };

  const onEndReached = function () {
    if (!loading && hasMore) {
      getData(++pageIndex);
    }
  };

  const handleFilterSelect = async ({ id, value }) => {
    let attr = {};
    if (value) {
      for (let i in attrData) {
        if (i !== value) {
          attr[i] = attrData[i];
        } else {
          break;
        }
      }
      const response = await getCategory({ id: value });
      if (
        response &&
        response.success &&
        response.data &&
        response.data.children &&
        response.data.children.length > 0
      ) {
        attr[value] = {
          label: response.data.categoryName,
          list: response.data.children.map((item) => ({
            name: item.categoryName,
            value: item.id,
          })),
        };
      } else {
        attr = {};
        for (let i in attrData) {
          attr[i] = attrData[i];
          if (i === id) {
            break;
          }
        }
      }
    } else {
      for (let i in attrData) {
        attr[i] = attrData[i];
        if (i === id) {
          break;
        }
      }
    }
    setAttrData(attr);
  };

  const history = useHistory();

  useEffect(() => {
    getData(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, name]);

  useEffect(() => {
    setFilters(
      <Filter
        data={attrData}
        enableTime={false}
        onSelect={handleFilterSelect}
        key={attrData.length === 0 && new Date().getTime()}
        handleSearch={(item) => {
          const categoryId = last(
            Object.keys(item)
              .map((id) => item[id])
              .filter((categoryId) => categoryId),
          );
          setFilter({
            categoryId,
          });
        }}
        onReset={() => {
          const [key] = Object.keys(attrData);
          setAttrData({ [key]: attrData[key] });
        }}
      ></Filter>,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attrData]);

  useEffect(() => {
    getAttrData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const listRef = useRef();
  const row = (rowData, sectionID, rowID) => {
    const { resId, title, coverUrl, deptName, createrName, resAttributeDetailList } = rowData;
    return (
      <li
        className="res-list-item"
        key={rowID}
        onClick={() => history.push(`${preRouteUrl}/resPlay/${resId}`)}
      >
        <div className="post">
          <img src={coverUrl ? coverUrl : resCover} alt="" />
        </div>
        <div className="info">
          <p className="title">{title}</p>
          <div className="dept-teacher">
            <span className="cut">{deptName}</span>
            <span className="line"></span>
            <span className="cut">{createrName}</span>
          </div>
          <div className="tags">
            {resAttributeDetailList
              ? resAttributeDetailList.map(
                  (item, index) =>
                    index !== 0 && (
                      <Tag small key={item.attributeId} className="tag">
                        {item.attributeValueName}
                      </Tag>
                    ),
                )
              : null}
          </div>
          {/* <div className="watch">
            <svg
              class="icon"
              viewBox="0 0 1490 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="3135">
              <path d="M737.640565 43.727581C314.544984 43.727581 50.155535 512 50.155535 512s261.859496 468.272419 687.478783 468.272419c398.102145 0 700.25973-468.272419 700.25973-468.272419S1138.222689 43.727581 737.640565 43.727581L737.640565 43.727581zM741.407384 699.535102c-103.053415 0-186.516874-83.725824-186.516874-187.010371s83.500939-187.047851 186.516874-187.047851c103.015934 0 186.554354 83.757058 186.554354 187.047851S844.423318 699.535102 741.407384 699.535102L741.407384 699.535102z"
                p-id="3136">
              </path>
            </svg>
            <span>{}人在看</span>
          </div> */}
        </div>
      </li>
    );
  };
  return (
    <ListView
      ref={listRef}
      dataSource={dataSource}
      renderHeader={() => <SearchWrapper onChange={setSearchName}></SearchWrapper>}
      renderFooter={() => (
        <div style={{ padding: 30, textAlign: 'center' }}>
          {hasMore ? (loading ? '加载中...' : '加载完成') : '没有更多'}
        </div>
      )}
      renderBodyComponent={() => <ListWrap />}
      renderRow={row}
      className="res-list-wrap"
      pageSize={pageSize}
      scrollRenderAheadDistance={500}
      onEndReached={onEndReached}
      onEndReachedThreshold={10}
      pullToRefresh={
        <PullToRefresh
          refreshing={draging}
          onRefresh={() => {
            setDraging();
            getData();
          }}
        />
      }
    />
  );
}

export default ResList;
